// ImageUpload.js (React component with Bootstrap)
import React, { useState } from 'react';
import axios from 'axios';        
import SimpleToast from "../SimpleFinder/SimpleToast"

const ImageUpload = (props) => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [fileCount, setFileCount] = useState(0);  // Track number of selected files

  const {location_id_resData, api_web_address, update_loc_loading, isLoading, activateLocToaster, toaster, getThumbnails} = props;
  //console.log('location_id_resData: ', location_id_resData )

  if (location_id_resData.length === 0) return <></>
  const loc_id = location_id_resData[0].id

  // Handle multiple image selections
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    
    // Update the selected images and previews
    setSelectedImages((prevImages) => [...prevImages, ...files]);
    const newPreviews = files.map((file) => URL.createObjectURL(file));
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    
    // Update the file count
    setFileCount((prevCount) => prevCount + files.length);
  };

  // Handle image removal
  const handleRemoveImage = (indexToRemove) => {
    setSelectedImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
    setPreviews((prevPreviews) =>
      prevPreviews.filter((_, index) => index !== indexToRemove)
    );

    // Decrement file count by 1 when an image is removed
    setFileCount((prevCount) => prevCount - 1);
  };

  // Handle image upload
  const handleUpload = async () => {
    if (!selectedImages.length) {
      alert('Please select images first!');
      return;
    }

    const formData = new FormData();
    selectedImages.forEach((image) => formData.append('images', image));
    console.log(loc_id)
    formData.append('loc_id', Number(loc_id));
    update_loc_loading(true)
    try {
      //const response = await axios.post('https://api-images-uploader.tg41.uk/upload', formData, {
      const response = await axios.post(`${api_web_address}/upload`, formData, {  
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      //console.log(response.data);
      activateLocToaster({className: "p-3 my-2 rounded bg-success", body: "Images uploaded successfully!"})
      //alert('Images uploaded successfully!');
      setSelectedImages([]);
      setPreviews([]);
      setFileCount(0);  // Reset file count after successful upload
      //location_id_resData  //loc_id
      getThumbnails(loc_id) //update thumbnails set
    } catch (error) {
      console.error('Error uploading the images', error);
      activateLocToaster({className: "p-3 my-2 rounded bg-danger", body: "Failed to upload images'!"})
      //alert('Failed to upload images');
    }
    update_loc_loading(false)
  };

  const delay = (ms) => {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, ms)
    })
  }


  return (
    <div className="container mt-5 border p-2">
      <h2 className="text-center">Upload Images</h2>

      <div className="mb-3 border p-2">
        <input
          type="file"
          id="fileInput"
          className="d-none" // Hide the default file input
          accept="image/*"
          multiple
          onChange={handleImageChange}
        />
        <label htmlFor="fileInput" className="btn btn-primary">
          Select Images
        </label>
      </div>

      {/* Display the count of selected files */}
      {fileCount > 0 && (
        <p className="text-center">{fileCount} file(s) selected</p>
      )}

      {/* Thumbnail previews with remove option */}
      {previews.length > 0 && (
        <div className="row mb-4">
          {previews.map((preview, index) => (
            <div className="col-md-3 mb-3" key={index}>
              <div className="card position-relative">
                <img
                  src={preview}
                  alt={`Selected ${index}`}
                  className="card-img-top"
                  style={{ height: '200px', objectFit: 'cover' }}
                />
                <div className="card-body text-center">
                  {/* Check if selectedImages[index] exists before rendering the name */}
                  {selectedImages[index] && (
                    <p className="card-text">{selectedImages[index].name}</p>
                  )}
                </div>
                <button
                  className="btn btn-danger btn-sm position-absolute"
                  style={{ top: '10px', right: '10px' }}
                  onClick={() => handleRemoveImage(index)}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <SimpleToast 
        toaster={toaster}
      />  

      {/* Upload button */}
      <div className={`${selectedImages.length === 0 ? "d-none" : "text-center"}`}> 
        <button
          className="btn btn-primary"
          onClick={handleUpload}
          disabled={selectedImages.length === 0}
        >
          {isLoading && (
              <span className="spinner-border spinner-border-sm"></span>
          )}
          Upload Images
        </button>
      </div>
    </div>
  );
};

export default ImageUpload;
